var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBiologicalAge = function SvgBiologicalAge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#537A5E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.017 21.51c-1.839-.65-4.368-1.08-6.547-1.127M5.4 21.51c1.915-.65 4.773-1.175 7.07-1.127m0 0c.106-1.578 0-3.257-.155-3.82m-4.583-6.64c.803.503 2.203 1.716 2.915 2.949m0 0c-3.456.53-5.915.249-7.812-5.745 5.737-1.148 10.233.82 7.812 5.745m0 0c.798 1.161 1.188 1.944 1.668 3.692m0 0c0-1.594 1.218-4.15 1.874-5.277m3.137-3.884c-.457.365-1.952 1.847-3.137 3.884m0 0c-1.719-3.162-.546-8.278 7.358-8.278 0 6.812-3.407 9.169-7.358 8.278"
  })));
};
export default SvgBiologicalAge;